import { useReduxState } from 'hooks';

interface Props {
  html: string;
  prefix?: React.ReactNode;
  prefixStyle?: React.CSSProperties;
  innerStyle?: React.CSSProperties;
  linkColor?: string;
  paragraphSpacing?: number;
  style?: React.CSSProperties;
}

const RichTextValue = ({
  html,
  innerStyle,
  linkColor,
  paragraphSpacing = 8,
  style
}: Props) => {
  const { theme } = useReduxState();

  return (
    <div className="rich-text" style={style}>
      <div dangerouslySetInnerHTML={{ __html: html }} style={innerStyle} />

      <style jsx>{`
        .rich-text :global(p) {
          margin: ${`${paragraphSpacing}px 0 0`};
          word-break: break-word;
        }
        .rich-text :global(p:first-child) {
          margin: 0;
        }
        .rich-text :global(a) {
          color: ${linkColor || theme.linkColor};
        }
      `}</style>
    </div>
  );
};

export default RichTextValue;
